import * as z from "zod/v4";

export const checkPermissionsV2 = {
  name: "checkPermissionsV2" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean() }),
};
